var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',[_c('span',{staticClass:"label-text"},[_vm._t("default")],2),(_vm.tooltipKey)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.$t(_vm.tooltipKey)),expression:"$t(tooltipKey)"}],staticClass:"icon-tooltip-wrapper"},[_c('i',{staticClass:"ui icon hint suus-alert-circle-que"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }